/**
 * Runtime Configuration
 * Fetches environment-specific config from express-backend at startup,
 * so values like the sabaody gateway URL don't need to be baked into the bundle.
 */ let sabaodyUrl = '';
let fliptUrl = ''; // same-origin: webpack proxy → sabaody → Flipt (avoids CORS)
export async function loadRuntimeConfig() {
    try {
        const res = await fetch('/api/config');
        if (res.ok) {
            const config = await res.json();
            sabaodyUrl = config.sabaodyUrl || '';
            if (config.fliptUrl) {
                fliptUrl = config.fliptUrl;
            }
        }
    } catch  {
    // Fallback: empty string means same-origin (local dev with webpack proxy)
    }
}
export function getSabaodyUrl() {
    return sabaodyUrl;
}
export function getFliptUrl() {
    return fliptUrl;
}
